export default "__VITE_ASSET__BfBGJlRU__"